<h1 mat-dialog-title>Warning</h1>
<div mat-dialog-content>
    <p>You currently have content in this article. Using this tool will overwrite all work in this assignment. Do you want to continue?</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</div>